import { downloadBlob, getBlob } from "../../common/actions/net";
import { messageType, pushSystemMessage } from "../../common/actions/systemMessage";

import { ContentTypes } from "../../common/net/httpClient";
import Logger from "../../common/util/Logger";

/**
 * Downloads a pdf with barcodes for current list
 * @param {string} token
 * @param {Object} product
 * @param {boolean} chain
 * @returns {func}
 */
export function downloadHmsPdf(token, product, chain){
    return async (dispatch) => {
        try {
            const endpoint = chain === true ? "Product/HmsDataSheetQueryChain" : "Product/HmsDataSheetQuery";
            const blob = await getBlob(endpoint, {productId: product.productId}, token, ContentTypes.JSON, ContentTypes.PDF, false);
            downloadBlob(blob, `HMS-${product.productId}.pdf`, ContentTypes.PDF);

        } catch (error) {
            dispatch(pushSystemMessage(error && error.message || "Downloading pdf failed", messageType.error));
            Logger.error(error);
        }
    };
}